// Quantities, printed the way people write them (Task 24808).
//
// Every quantity column in the database is DECIMAL(20,6), so the API hands back
// "1.000000" and anything printing it raw shows exactly that. The rule asked
// for, and the one applied here:
//
//   2.000000  ->  2          hide the zeros when there is nothing after the point
//   2.500000  ->  2.5        keep what is actually there
//   2.567000  ->  2.57       never more than two decimal places
//
// Two places is the cap rather than the fixed width, which is why this is not
// toFixed(2): that turns 1 into "1.00" and puts noise back on screen, just
// tidier noise. toLocaleString with only a MAXIMUM trims trailing zeros for us
// and gets thousands separators right at the same time.
//
// Returns null for an empty value so a caller can render a dash, rather than
// printing "0" for "not set" - those are different facts about a line.
export const formatQuantity = (value) => {
  if (value === null || value === undefined || value === "") return null;

  const num = Number(value);
  if (!Number.isFinite(num)) return null;

  return num.toLocaleString("en-GB", { maximumFractionDigits: 2 });
};

export default formatQuantity;
